export const templates = [
  {
    id: 'tpl-1',
    name: '极简企业官网',
    category: '企业官网',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20corporate%20website%20homepage%20design%20mockup%20on%20laptop%20screen%2C%20minimalist%20white%20and%20warm%20tone%20layout%2C%20professional%20business%20aesthetic%2C%20geometric%20shapes%2C%20soft%20lighting%2C%20UI%20design%20presentation&width=600&height=400&seq=template-enterprise-01&orientation=landscape',
    description: '适合科技、服务类企业，简洁大气的设计风格',
    features: ['响应式设计', 'SEO优化', '联系表单', '案例展示'],
  },
  {
    id: 'tpl-2',
    name: '创意博客模板',
    category: '个人博客',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20blog%20website%20design%20mockup%20displayed%20on%20laptop%2C%20minimalist%20typography%20focused%20layout%2C%20warm%20cream%20background%2C%20editorial%20design%20aesthetic%2C%20clean%20reading%20experience%2C%20soft%20natural%20lighting&width=600&height=400&seq=template-blog-02&orientation=landscape',
    description: '专为内容创作者设计，突出文字之美',
    features: ['分类标签', '搜索功能', '评论区', '社交媒体分享'],
  },
  {
    id: 'tpl-3',
    name: '电商商城模板',
    category: '电商店铺',
    image: 'https://readdy.ai/api/search-image?query=Modern%20ecommerce%20website%20design%20mockup%20on%20laptop%20screen%2C%20product%20grid%20layout%20with%20clean%20white%20background%2C%20minimalist%20shopping%20interface%2C%20warm%20accent%20colors%2C%20professional%20online%20store%20aesthetic&width=600&height=400&seq=template-ecommerce-03&orientation=landscape',
    description: '完整的在线商城功能，支持商品管理和支付',
    features: ['商品展示', '购物车', '支付接入', '订单管理'],
  },
  {
    id: 'tpl-4',
    name: '设计师作品集',
    category: '作品集',
    image: 'https://readdy.ai/api/search-image?query=Creative%20portfolio%20website%20design%20mockup%20on%20laptop%2C%20image%20heavy%20layout%20with%20elegant%20grid%2C%20minimalist%20designer%20portfolio%20aesthetic%2C%20warm%20neutral%20tones%2C%20professional%20creative%20presentation&width=600&height=400&seq=template-portfolio-04&orientation=landscape',
    description: '视觉冲击力强，完美展示设计作品',
    features: ['瀑布流布局', '项目详情页', '关于我', '联系页面'],
  },
  {
    id: 'tpl-5',
    name: '餐饮美食模板',
    category: '餐饮美食',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20restaurant%20website%20design%20mockup%20on%20laptop%2C%20food%20focused%20layout%20with%20beautiful%20imagery%2C%20warm%20inviting%20color%20palette%2C%20menu%20display%20design%2C%20professional%20hospitality%20aesthetic&width=600&height=400&seq=template-restaurant-05&orientation=landscape',
    description: '美食展示效果出色，支持在线点餐预约',
    features: ['菜单展示', '在线预约', '位置导航', '顾客评价'],
  },
  {
    id: 'tpl-6',
    name: '教育培训模板',
    category: '教育培训',
    image: 'https://readdy.ai/api/search-image?query=Modern%20educational%20website%20design%20mockup%20on%20laptop%20screen%2C%20clean%20course%20listing%20layout%2C%20professional%20academic%20aesthetic%2C%20warm%20inviting%20design%2C%20soft%20cream%20and%20wood%20tones&width=600&height=400&seq=template-education-06&orientation=landscape',
    description: '课程展示清晰，助力培训机构线上招生',
    features: ['课程展示', '师资介绍', '报名表单', '学员案例'],
  },
];

export const templateCategories = ['全部', '企业官网', '个人博客', '电商店铺', '作品集', '餐饮美食', '教育培训'];